import type { history as historyEn } from '../en/history';

export const history: typeof historyEn = {
  title: 'Historial',
  subtitle: 'Todo lo que ha registrado, listo para los chequeos',
  filterLabel: 'Mostrar solo',
  filterAll: 'Todo',

  daySummary: {
    feeds: (n: number) => (n === 1 ? '1 toma' : `${n} tomas`),
    wet: (n: number) => (n === 1 ? '1 mojado' : `${n} mojados`),
    dirty: (n: number) => (n === 1 ? '1 sucio' : `${n} sucios`),
    pumped: (amount: string) => `${amount} extraídos`,
    slept: (duration: string) => `${duration} de sueño`,
  },

  row: {
    breast: 'Pecho',
    bottle: 'Biberón',
    sideDuration: (side: string, duration: string) => `${side} ${duration}`,
    diaperWet: 'Mojado',
    diaperDirty: 'Sucio',
    diaperBoth: 'Mojado y sucio',
    atBirthWeight: 'En su peso de nacimiento',
    belowBirthWeight: (pct: number) => `${pct}% por debajo del peso de nacimiento`,
    aboveBirthWeight: (pct: number) => `${pct}% por encima del peso de nacimiento`,
    sleepOngoing: 'Todavía dormido',
  },

  empty: {
    title: 'Aún no hay registros',
    body: 'Las tomas, los pañales, los pesos, las extracciones y el sueño que registre en la pestaña Registrar aparecerán aquí, organizados por día. Así será fácil responder las preguntas en los chequeos de su bebé.',
    cta: 'Ir a Registrar',
    noMatches: 'Aún no hay nada en esta categoría. Pruebe otro filtro o elija Todo.',
  },

  showEarlier: 'Mostrar días anteriores',
};
